import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Menu } from 'semantic-ui-react';
import FindWorks from '../find_works';
import FindFavorites from '../find_favorites';
import PanelLayout from '../panel/layout';
import PinButton from '../shared/pin';
import * as classes from '../find_works/classes';

const AddArt = ({ closePanel, pinned, togglePin }) => {
  const [currentTab, setTab] = useState(0);

  const content = currentTab === 0 ? <FindWorks allowApi /> : (
    <>
      <p className={ classes.aboutFavs }>
        Easily create and style your art groupings while browsing the site -
        just mark your favorites as you browse the site (with the heart icon -&nbsp;
        <i className="icon-heart" />
        ),
        <br />
        and you can access them from here when designing your combinations.
      </p>
      <FindFavorites allowApi />
    </>
  );

  const title = (
    <div className={ classes.headerTabs }>
      <div className={ classes.tabs }>
        <Menu pointing secondary>
          <Menu.Item
            name="All Art"
            active={ currentTab === 0 }
            onClick={ () => setTab(0) }
          />
          <Menu.Item
            name="My Favorites"
            active={ currentTab === 1 }
            onClick={ () => setTab(1) }
          />
        </Menu>
      </div>
      <PinButton pinned={ pinned } togglePin={ togglePin } />
    </div>
  );

  return (
    <PanelLayout
      onClose={ closePanel }
      title={ title }
      headerClass={ classes.header }
    >
      <div className={ classes.container }>
        { content }
      </div>
    </PanelLayout>
  );
};

AddArt.propTypes = {
  closePanel: PropTypes.func.isRequired,
  pinned: PropTypes.bool.isRequired,
  togglePin: PropTypes.func.isRequired
};

export default AddArt;
